<template>
    <div>
        <div id="main-dif" v-show="!rotaAninhada">
            <container-loader v-if="isLoading && !$store.getters.isLoading" />
            <div class="page">
                <div class="vertical-flow">
                    <div class="listing-header">
                        <!-- TÍTULO E BREADCRUMB -->
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t("conta-corrente") }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("vendas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("financeiro")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("conta-corrente")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="header-buttons">
                            <button
                                class="delete-btn"
                                type="button"
                                tag="button"
                                @click="
                                    $router.push({
                                        name: 'flex-list',
                                    })
                                "
                            >
                                {{ $t("voltar") }}
                            </button>
                            <button
                                v-if="!integracao && permissao.create"
                                class="save-btn"
                                type="button"
                                tag="button"
                                @click="showModalFlexLancamentoManage = true"
                            >
                                {{ $t("adicionar-saldo") }}
                            </button>
                        </div>
                    </div>

                    <ul class="nav nav-tabs nav-tabs-children">
                        <li
                            v-for="(aba, i) in abas"
                            :key="i"
                            v-show="listaPermissoes[aba].read"
                            :class="{ active: abaSelecionada == i }"
                            @click="changeTab(i)"
                        >
                            <a data-toggle="tab">{{ $t(aba) }}</a>
                        </li>
                    </ul>

                    <!-- CONJTO DE ABAS - MOBILE -->
                    <b-dropdown aria-role="list" class="mobile-tab-list">
                        <div slot="trigger" class="mobile-tab">
                            <span class="mobile-tab-text">
                                {{ $t(abas[abaSelecionada]) }}
                            </span>
                            <em class="mdi mdi-chevron-down"></em>
                        </div>

                        <b-dropdown-item
                            class="mobile-tab-list-item"
                            :class="{ active: abaSelecionada == i }"
                            aria-role="listitem"
                            v-for="(aba, i) in abas"
                            v-show="listaPermissoes[aba].read"
                            :key="i"
                            @click="changeTab(i)"
                        >
                            {{ $t(aba) }}
                        </b-dropdown-item>
                    </b-dropdown>

                    <Geral
                        ref="tabGeral"
                        v-if="
                            abasAbertas['geral'] &&
                            listaPermissoes['geral'].read
                        "
                        :contaFlex="contaFlex"
                        v-show="abas[abaSelecionada] == 'geral'"
                        @isChanged="isChanged = $event"
                    />
                    <Movimentacao
                        ref="tabMovimentacao"
                        v-if="
                            abasAbertas['movimentacao'] &&
                            listaPermissoes['movimentacao'].read
                        "
                        :contaFlex="contaFlex"
                        v-show="abas[abaSelecionada] == 'movimentacao'"
                        @isChanged="isChanged = $event"
                    />
                    <Bloqueado
                        ref="tabBloqueado"
                        v-if="
                            contaFlex.regraTrabalho === 0 &&
                            contaFlex.operacao != 2 &&
                            abasAbertas['bloqueado'] &&
                            listaPermissoes['bloqueado'].read
                        "
                        :contaFlex="contaFlex"
                        v-show="abas[abaSelecionada] == 'bloqueado'"
                        @updateContaFlex="
                            if ($refs.tabMovimentacao) {
                                $refs.tabMovimentacao.recarregarDados();
                            }

                            carregarDados();
                        "
                        @isChanged="isChanged = $event"
                    />
                    <Configuracoes
                        ref="tabConfiguracoes"
                        v-if="
                            abasAbertas['configuracoes'] &&
                            listaPermissoes['configuracoes'].read
                        "
                        :contaFlex="contaFlex"
                        @isContaFlexLoading="isLoading = true"
                        @contaFlexLoadingBreak="isLoading = false"
                        @saved="carregarDados"
                        v-show="abas[abaSelecionada] == 'configuracoes'"
                        @isChanged="isChanged = $event"
                    />
                </div>
                <lateral-content
                    v-model="showModalFlexLancamentoManage"
                    compact
                >
                    <FlexLancamentoManage
                        class="pt-4"
                        v-if="showModalFlexLancamentoManage"
                        :contaFlex="contaFlex"
                        @saved="
                            showModalFlexLancamentoManage = false;

                            if ($refs.tabMovimentacao) {
                                $refs.tabMovimentacao.recarregarDados();
                            }

                            carregarDados();
                        "
                        @voltar="showModalFlexLancamentoManage = false"
                    />
                </lateral-content>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import Geral from "@/components/vendas/financeiro/flex/abas/Geral.vue";
import Movimentacao from "@/components/vendas/financeiro/flex/abas/Movimentacao.vue";
import Bloqueado from "@/components/vendas/financeiro/flex/abas/Bloqueado.vue";
import Configuracoes from "@/components/vendas/financeiro/flex/abas/Configuracoes.vue";
import FlexLancamentoManage from "@/components/vendas/financeiro/flex/FlexLancamentoManage.vue";
import FlexService from "@/services/vendas/financeiro/FlexService.js";

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes("detail") && to.name != "flex-detail") {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            next();
        }
    },
    components: {
        ContainerLoader,
        Geral,
        Movimentacao,
        Bloqueado,
        Configuracoes,
        FlexLancamentoManage,
    },
    data() {
        return {
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("VEN_FLEX"),
            service: new FlexService(this.$http, this.$router),
            isLoading: false,
            permissao: {},
            abaSelecionada: 0,
            abas: ["geral", "movimentacao", "bloqueado", "configuracoes"],
            abasAbertas: {},
            listaPermissoes: {},
            showModalFlexLancamentoManage: false,
            contaFlex: {
                venIdFlexErp: "",
                nomeEmpresa: "",
                nomeUsuario: "",
                situacao: null,
                saldoTotalLiberado: 0,
                saldoTotalBloqueado: 0,
            },
        };
    },
    created() {
        if (
            this.$route.name.includes("flex") &&
            this.$route.name != "flex-detail"
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.permissao = this.hasPermissionAccess(
            "vendas",
            "financeiro",
            "flex"
        );

        if (!this.permissao.create || !this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "flex" },
            });
        } else {
            for (let [key, value] of Object.entries(this.abas)) {
                this.abasAbertas[value] = false;
                this.listaPermissoes[value] = this.hasPermissionAccess(
                    "vendas",
                    "financeiro",
                    "flex"
                );
            }

            for (let [key, value] of Object.entries(this.listaPermissoes)) {
                if (value.read) {
                    this.abaSelecionada = this.abas.findIndex((e) => e == key);
                    this.abasAbertas[key] = true;
                    break;
                }
            }

            this.carregarDados();
        }
    },
    methods: {
        carregarDados() {
            this.isLoading = true;

            this.service
                .findByIdCustom(this.$route.params.id)
                .then(({ content }) => {
                    this.contaFlex = content;
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-load");
                })
                .finally((_) => {
                    this.isLoading = false;

                    this.listaPermissoes["bloqueado"].read =
                        this.contaFlex.regraTrabalho === 0 &&
                        this.contaFlex.operacao != 2;

                    const abaSelecionada = this.$route.query.aba;
                    if (abaSelecionada) {
                        this.changeTab(abaSelecionada);
                    }
                });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
            this.$router.push({ query: { aba: i } });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;
}

.page {
    padding: 0 20px;
    position: relative;

    .nav-tabs-children {
        margin-bottom: 20px;

        li > a {
            text-transform: capitalize;
        }

        li > ::after {
            bottom: -4px;
            border-width: 2px;
        }
    }

    .mobile-tab {
        cursor: pointer;

        &-list {
            width: calc(100% + 40px);
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: -20px;
            padding-right: 20px;
            padding-bottom: 5px;
            padding-left: 20px;
            border-bottom: 1px solid $table-border;
            justify-content: center;

            &::after {
                content: "";
                border: 3px solid $primary-color-click;
                border-radius: 100px;
                position: absolute;
                width: calc(100% - 40px);
                bottom: -3px;
            }

            &-item {
                text-transform: uppercase;
                font-weight: 600;
                color: $text-color;

                &.active {
                    color: $primary-color-click;
                }
            }
        }

        &-text {
            text-transform: uppercase;
            font-weight: 600;
            color: $primary-color-click;

            & ~ i {
                color: $primary-color-click;
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
